import { APP_INITIALIZER } from '@angular/core';
import { SvgIconRegistryService } from 'src/app/common/icon/icon-registry.service';
import arrowLeft from 'src/assets/icons/phosphor/arrow-left.svg';
import bed from 'src/assets/icons/phosphor/bed.svg';
import bell from 'src/assets/icons/phosphor/bell.svg';
import beerBottle from 'src/assets/icons/phosphor/beer-bottle.svg';
import bookmarkSimple from 'src/assets/icons/phosphor/bookmark-simple.svg';
import bookmarkFill from 'src/assets/icons/phosphor/bookmark-fill.svg';
import calendar from 'src/assets/icons/phosphor/calendar.svg';
import calendarBlank from 'src/assets/icons/phosphor/calendar-blank.svg';
import car from 'src/assets/icons/phosphor/car.svg';
import caretDown from 'src/assets/icons/phosphor/caret-down.svg';
import caretLeft from 'src/assets/icons/phosphor/caret-left.svg';
import caretRight from 'src/assets/icons/phosphor/caret-right.svg';
import chartBar from 'src/assets/icons/phosphor/chart-bar.svg';
import chatCircleText from 'src/assets/icons/phosphor/chat-circle-text.svg';
import chatText from 'src/assets/icons/phosphor/chat-text.svg';
import clock from 'src/assets/icons/phosphor/clock.svg';
import backpackCustom from 'src/assets/icons/custom/backpack.svg';
import belloCustom from 'src/assets/icons/custom/bello.svg';
import bookmarkSimpleStrokedCustom from 'src/assets/icons/custom/bookmark-simple-stroked.svg';
import carBikeCustom from 'src/assets/icons/custom/car-bike.svg';
import cookieCustom from 'src/assets/icons/custom/cookie.svg';
import eventCustom from 'src/assets/icons/custom/event.svg';
import quantitaCustom from 'src/assets/icons/custom/quantita.svg';
import stripeOutlineCustom from 'src/assets/icons/custom/stripe-outline.svg';
import suMisuraCustom from 'src/assets/icons/custom/su-misura.svg';
import userCircleCustom from 'src/assets/icons/custom/user-circle.svg';
import workerCustom from 'src/assets/icons/custom/worker.svg';
import cherrymeterCustom from 'src/assets/icons/custom/cherrymeter.svg';
import wheelCustom from 'src/assets/icons/custom/wheel.svg';
import iMieiAcquistiCustom from 'src/assets/icons/custom/i-miei-acquisti.svg';
import dotsThreeVertical from 'src/assets/icons/phosphor/dots-three-vertical.svg';
import eye from 'src/assets/icons/phosphor/eye.svg';
import eyeSlash from 'src/assets/icons/phosphor/eye-slash.svg';
import facebookLogo from 'src/assets/icons/phosphor/facebook-logo.svg';
import gear from 'src/assets/icons/phosphor/gear.svg';
import globe from 'src/assets/icons/phosphor/globe.svg';
import gift from 'src/assets/icons/phosphor/gift.svg';
import handbag from 'src/assets/icons/phosphor/handbag.svg';
import house from 'src/assets/icons/phosphor/house.svg';
import info from 'src/assets/icons/phosphor/info.svg';
import instagramLogo from 'src/assets/icons/phosphor/instagram-logo.svg';
import linkedinLogo from 'src/assets/icons/phosphor/linkedin-logo.svg';
import list from 'src/assets/icons/phosphor/list.svg';
import lockKey from 'src/assets/icons/phosphor/lock-key.svg';
import lockSimpleOpen from 'src/assets/icons/phosphor/lock-simple-open.svg';
import magnifyingGlass from 'src/assets/icons/phosphor/magnifying-glass.svg';
import mapTrifold from 'src/assets/icons/phosphor/map-trifold.svg';
import note from 'src/assets/icons/phosphor/note.svg';
import pencil from 'src/assets/icons/phosphor/pencil.svg';
import pencilLine from 'src/assets/icons/phosphor/pencil-line.svg';
import pencilSimple from 'src/assets/icons/phosphor/pencil-simple.svg';
import plusCircle from 'src/assets/icons/phosphor/plus-circle.svg';
import scales from 'src/assets/icons/phosphor/scales.svg';
import shareNetwork from 'src/assets/icons/phosphor/share-network.svg';
import signIn from 'src/assets/icons/phosphor/sign-in.svg';
import signOut from 'src/assets/icons/phosphor/sign-out.svg';
import sliders from 'src/assets/icons/phosphor/sliders.svg';
import star from 'src/assets/icons/phosphor/star.svg';
import swatches from 'src/assets/icons/phosphor/swatches.svg';
import user from 'src/assets/icons/phosphor/user.svg';
import userCircle from 'src/assets/icons/phosphor/user-circle.svg';
import userPlus from 'src/assets/icons/phosphor/user-plus.svg';
import users from 'src/assets/icons/phosphor/users.svg';
import usersThree from 'src/assets/icons/phosphor/users-three.svg';
import x from 'src/assets/icons/phosphor/x.svg';
import youtubeLogo from 'src/assets/icons/phosphor/youtube-logo.svg';
import wifiSlash from 'src/assets/icons/phosphor/wifi-slash.svg';
import preferitiCustom from 'src/assets/icons/custom/preferiti.svg';
import preferitiMobile from 'src/assets/icons/phosphor/preferiti-mobile.svg';
import carrello from 'src/assets/icons/phosphor/carrello.svg';
import icoCommunity from 'src/assets/icons/phosphor/ico-community.svg';
import icoCommunitySfumata from 'src/assets/icons/phosphor/ico-community-sfumata.svg';
import farm from 'src/assets/icons/phosphor/farm.svg';
import grains from 'src/assets/icons/phosphor/grains.svg';
import mapPinArea from 'src/assets/icons/phosphor/map-pin-area.svg';
import windmill from 'src/assets/icons/phosphor/windmill.svg';
import icoRaccolta from 'src/assets/icons/phosphor/ico-raccolta.svg';
import verifiedCustom from 'src/assets/icons/custom/verified.svg';
import ambassadorNoCircleCustom from 'src/assets/icons/custom/ambassador-no-circle.svg';
import appleFillCustom from 'src/assets/icons/custom/apple-fill.svg';
import clappingCustom from 'src/assets/icons/custom/clapping.svg';
import clappingCircleCustom from 'src/assets/icons/custom/clapping-circle.svg';
import facebookFillCustom from 'src/assets/icons/custom/facebook-fill.svg';
import friendlyMunicipalityCustom from 'src/assets/icons/custom/friendly-municipality.svg';
import googleFillCustom from 'src/assets/icons/custom/google-fill.svg';
import googlePlayFillCustom from 'src/assets/icons/custom/google-play-fill.svg';
import icParlaConNoiCustom from 'src/assets/icons/custom/ic-parla-con-noi.svg';
import infoDuotoneCustom from 'src/assets/icons/custom/info-duotone.svg';
import landFollowActiveCustom from 'src/assets/icons/custom/land-follow-active.svg';
import mapPinFillCustom from 'src/assets/icons/custom/map-pin-fill.svg';
import paladinCustom from 'src/assets/icons/custom/paladin.svg';
import playFillCustom from 'src/assets/icons/custom/play-fill.svg';
import regionCustom from 'src/assets/icons/custom/region.svg';
import sunAndMoonCustom from 'src/assets/icons/custom/sun-and-moon.svg';
import arrowDown from 'src/assets/icons/phosphor/arrow-down.svg';
import arrowRight from 'src/assets/icons/phosphor/arrow-right.svg';
import arrowSquareOut from 'src/assets/icons/phosphor/arrow-square-out.svg';
import arrowUp from 'src/assets/icons/phosphor/arrow-up.svg';
import arrowsDownUp from 'src/assets/icons/phosphor/arrows-down-up.svg';
import at from 'src/assets/icons/phosphor/at.svg';
import bag from 'src/assets/icons/phosphor/bag.svg';
import bank from 'src/assets/icons/phosphor/bank.svg';
import bellRinging from 'src/assets/icons/phosphor/bell-ringing.svg';
import binoculars from 'src/assets/icons/phosphor/binoculars.svg';
import bookOpen from 'src/assets/icons/phosphor/book-open.svg';
import calendarCheck from 'src/assets/icons/phosphor/calendar-check.svg';
import calendarPlus from 'src/assets/icons/phosphor/calendar-plus.svg';
import calendarX from 'src/assets/icons/phosphor/calendar-x.svg';
import caretDoubleLeft from 'src/assets/icons/phosphor/caret-double-left.svg';
import caretDoubleRight from 'src/assets/icons/phosphor/caret-double-right.svg';
import caretUp from 'src/assets/icons/phosphor/caret-up.svg';
import chatCircle from 'src/assets/icons/phosphor/chat-circle.svg';
import check from 'src/assets/icons/phosphor/check.svg';
import checkCircle from 'src/assets/icons/phosphor/check-circle.svg';
import coin from 'src/assets/icons/phosphor/coin.svg';
import cookingPot from 'src/assets/icons/phosphor/cooking-pot.svg';
import copy from 'src/assets/icons/phosphor/copy.svg';
import copyright from 'src/assets/icons/phosphor/copyright.svg';
import currencyEur from 'src/assets/icons/phosphor/currency-eur.svg';
import dotsThree from 'src/assets/icons/phosphor/dots-three.svg';
import dotsThreeCircleVertical from 'src/assets/icons/phosphor/dots-three-circle-vertical.svg';
import envelopeSimple from 'src/assets/icons/phosphor/envelope-simple.svg';
import envelopeSimpleOpen from 'src/assets/icons/phosphor/envelope-simple-open.svg';
import equals from 'src/assets/icons/phosphor/equals.svg';
import file from 'src/assets/icons/phosphor/file.svg';
import fileText from 'src/assets/icons/phosphor/file-text.svg';
import flag from 'src/assets/icons/phosphor/flag.svg';
import flagCheckered from 'src/assets/icons/phosphor/flag-checkered.svg';
import forkKnife from 'src/assets/icons/phosphor/fork-knife.svg';
import gearSix from 'src/assets/icons/phosphor/gear-six.svg';
import handbagSimple from 'src/assets/icons/phosphor/handbag-simple.svg';
import handshake from 'src/assets/icons/phosphor/handshake.svg';
import hash from 'src/assets/icons/phosphor/hash.svg';
import headset from 'src/assets/icons/phosphor/headset.svg';
import identificationCard from 'src/assets/icons/phosphor/identification-card.svg';
import imageSquare from 'src/assets/icons/phosphor/image-square.svg';
import images from 'src/assets/icons/phosphor/images.svg';
import link from 'src/assets/icons/phosphor/link.svg';
import mapPin from 'src/assets/icons/phosphor/map-pin.svg';
import mapPinLine from 'src/assets/icons/phosphor/map-pin-line.svg';
import minus from 'src/assets/icons/phosphor/minus.svg';
import minusCircle from 'src/assets/icons/phosphor/minus-circle.svg';
import notePencil from 'src/assets/icons/phosphor/note-pencil.svg';
import palette from 'src/assets/icons/phosphor/palette.svg';
import paperPlaneRight from 'src/assets/icons/phosphor/paper-plane-right.svg';
import pauseCircle from 'src/assets/icons/phosphor/pause-circle.svg';
import percent from 'src/assets/icons/phosphor/percent.svg';
import phone from 'src/assets/icons/phosphor/phone.svg';
import plus from 'src/assets/icons/phosphor/plus.svg';
import power from 'src/assets/icons/phosphor/power.svg';
import question from 'src/assets/icons/phosphor/question.svg';
import share from 'src/assets/icons/phosphor/share.svg';
import shieldCheck from 'src/assets/icons/phosphor/shield-check.svg';
import smiley from 'src/assets/icons/phosphor/smiley.svg';
import textBolder from 'src/assets/icons/phosphor/text-bolder.svg';
import textItalic from 'src/assets/icons/phosphor/text-italic.svg';
import ticket from 'src/assets/icons/phosphor/ticket.svg';
import timer from 'src/assets/icons/phosphor/timer.svg';
import trafficSign from 'src/assets/icons/phosphor/traffic-sign.svg';
import translate from 'src/assets/icons/phosphor/translate.svg';
import trash from 'src/assets/icons/phosphor/trash.svg';
import trashSimple from 'src/assets/icons/phosphor/trash-simple.svg';
import trophy from 'src/assets/icons/phosphor/trophy.svg';
import truck from 'src/assets/icons/phosphor/truck.svg';
import userSwitch from 'src/assets/icons/phosphor/user-switch.svg';
import usersFour from 'src/assets/icons/phosphor/users-four.svg';
import warning from 'src/assets/icons/phosphor/warning.svg';
import whatsappLogo from 'src/assets/icons/phosphor/whatsapp-logo.svg';
import wheelchair from 'src/assets/icons/phosphor/wheelchair.svg';
import xCircle from 'src/assets/icons/phosphor/x-circle.svg';
import xCircleFill from 'src/assets/icons/phosphor/x-circle-fill.svg';
import camera from 'src/assets/icons/phosphor/camera.svg';
import chat from 'src/assets/icons/phosphor/chat.svg';
import chatCircleDots from 'src/assets/icons/phosphor/chat-circle-dots.svg';
import clockClockwise from 'src/assets/icons/phosphor/clock-clockwise.svg';
import database from 'src/assets/icons/phosphor/database.svg';
import envelope from 'src/assets/icons/phosphor/envelope.svg';
import eraser from 'src/assets/icons/phosphor/eraser.svg';
import exportIcon from 'src/assets/icons/phosphor/export.svg';
import fileArrowUp from 'src/assets/icons/phosphor/file-arrow-up.svg';
import files from 'src/assets/icons/phosphor/files.svg';
import handHeart from 'src/assets/icons/phosphor/hand-heart.svg';
import houseObliqueCustom from 'src/assets/icons/custom/house-oblique.svg';
import image from 'src/assets/icons/phosphor/image.svg';
import landFollowCustom from 'src/assets/icons/custom/land-follow.svg';
import packageIcon from 'src/assets/icons/phosphor/package.svg';
import quizCustom from 'src/assets/icons/custom/quiz.svg';
import repeat from 'src/assets/icons/phosphor/repeat.svg';
import shoppingCart from 'src/assets/icons/phosphor/shopping-cart.svg';
import sketchLogo from 'src/assets/icons/phosphor/sketch-logo.svg';
import stack from 'src/assets/icons/phosphor/stack.svg';
import trolleyCustom from 'src/assets/icons/custom/trolley.svg';
import userFullCustom from 'src/assets/icons/custom/user-full.svg';
import wonderStarCustom from 'src/assets/icons/custom/wonder-star.svg';
import castleTurret from 'src/assets/icons/phosphor/castle-turret.svg';
import church from 'src/assets/icons/phosphor/church.svg';
import coffee from 'src/assets/icons/phosphor/coffee.svg';
import firstAidKit from 'src/assets/icons/phosphor/first-aid-kit.svg';
import pinwheel from 'src/assets/icons/phosphor/pinwheel.svg';
import roadHorizon from 'src/assets/icons/phosphor/road-horizon.svg';
import storefront from 'src/assets/icons/phosphor/storefront.svg';
import train from 'src/assets/icons/phosphor/train.svg';

// Icons bundled as strings, registered by name and by src: no HTTP requests at startup.
const ICONS: Record<string, string> = {
  'phosphor/arrow-left': arrowLeft,
  'phosphor/bed': bed,
  'phosphor/bell': bell,
  'phosphor/beer-bottle': beerBottle,
  'phosphor/bookmark-simple': bookmarkSimple,
  'phosphor/bookmark-fill': bookmarkFill,
  'phosphor/calendar': calendar,
  'phosphor/calendar-blank': calendarBlank,
  'phosphor/car': car,
  'phosphor/caret-down': caretDown,
  'phosphor/caret-left': caretLeft,
  'phosphor/caret-right': caretRight,
  'phosphor/chart-bar': chartBar,
  'phosphor/chat-circle-text': chatCircleText,
  'phosphor/chat-text': chatText,
  'phosphor/clock': clock,
  'custom/backpack': backpackCustom,
  'custom/bello': belloCustom,
  'custom/bookmark-simple-stroked': bookmarkSimpleStrokedCustom,
  'custom/car-bike': carBikeCustom,
  'custom/cookie': cookieCustom,
  'custom/event': eventCustom,
  'custom/quantita': quantitaCustom,
  'custom/stripe-outline': stripeOutlineCustom,
  'custom/su-misura': suMisuraCustom,
  'custom/user-circle': userCircleCustom,
  'custom/worker': workerCustom,
  'custom/cherrymeter': cherrymeterCustom,
  'custom/wheel': wheelCustom,
  'custom/i-miei-acquisti': iMieiAcquistiCustom,
  'phosphor/dots-three-vertical': dotsThreeVertical,
  'phosphor/eye': eye,
  'phosphor/eye-slash': eyeSlash,
  'phosphor/facebook-logo': facebookLogo,
  'phosphor/gear': gear,
  'phosphor/globe': globe,
  'phosphor/gift': gift,
  'phosphor/handbag': handbag,
  'phosphor/house': house,
  'phosphor/info': info,
  'phosphor/instagram-logo': instagramLogo,
  'phosphor/linkedin-logo': linkedinLogo,
  'phosphor/list': list,
  'phosphor/lock-key': lockKey,
  'phosphor/lock-simple-open': lockSimpleOpen,
  'phosphor/magnifying-glass': magnifyingGlass,
  'phosphor/map-trifold': mapTrifold,
  'phosphor/note': note,
  'phosphor/pencil': pencil,
  'phosphor/pencil-line': pencilLine,
  'phosphor/pencil-simple': pencilSimple,
  'phosphor/plus-circle': plusCircle,
  'phosphor/scales': scales,
  'phosphor/share-network': shareNetwork,
  'phosphor/sign-in': signIn,
  'phosphor/sign-out': signOut,
  'phosphor/sliders': sliders,
  'phosphor/star': star,
  'phosphor/swatches': swatches,
  'phosphor/user': user,
  'phosphor/user-circle': userCircle,
  'phosphor/user-plus': userPlus,
  'phosphor/users': users,
  'phosphor/users-three': usersThree,
  'phosphor/x': x,
  'phosphor/youtube-logo': youtubeLogo,
  'phosphor/wifi-slash': wifiSlash,
  'custom/preferiti': preferitiCustom,
  'phosphor/preferiti-mobile': preferitiMobile,
  'phosphor/carrello': carrello,
  'phosphor/ico-community': icoCommunity,
  'phosphor/ico-community-sfumata': icoCommunitySfumata,
  'phosphor/farm': farm,
  'phosphor/grains': grains,
  'phosphor/map-pin-area': mapPinArea,
  'phosphor/windmill': windmill,
  'phosphor/ico-raccolta': icoRaccolta,
  'custom/verified': verifiedCustom,
  'custom/ambassador-no-circle': ambassadorNoCircleCustom,
  'custom/apple-fill': appleFillCustom,
  'custom/clapping': clappingCustom,
  'custom/clapping-circle': clappingCircleCustom,
  'custom/facebook-fill': facebookFillCustom,
  'custom/friendly-municipality': friendlyMunicipalityCustom,
  'custom/google-fill': googleFillCustom,
  'custom/google-play-fill': googlePlayFillCustom,
  'custom/ic-parla-con-noi': icParlaConNoiCustom,
  'custom/info-duotone': infoDuotoneCustom,
  'custom/land-follow-active': landFollowActiveCustom,
  'custom/map-pin-fill': mapPinFillCustom,
  'custom/paladin': paladinCustom,
  'custom/play-fill': playFillCustom,
  'custom/region': regionCustom,
  'custom/sun-and-moon': sunAndMoonCustom,
  'phosphor/arrow-down': arrowDown,
  'phosphor/arrow-right': arrowRight,
  'phosphor/arrow-square-out': arrowSquareOut,
  'phosphor/arrow-up': arrowUp,
  'phosphor/arrows-down-up': arrowsDownUp,
  'phosphor/at': at,
  'phosphor/bag': bag,
  'phosphor/bank': bank,
  'phosphor/bell-ringing': bellRinging,
  'phosphor/binoculars': binoculars,
  'phosphor/book-open': bookOpen,
  'phosphor/calendar-check': calendarCheck,
  'phosphor/calendar-plus': calendarPlus,
  'phosphor/calendar-x': calendarX,
  'phosphor/caret-double-left': caretDoubleLeft,
  'phosphor/caret-double-right': caretDoubleRight,
  'phosphor/caret-up': caretUp,
  'phosphor/chat-circle': chatCircle,
  'phosphor/check': check,
  'phosphor/check-circle': checkCircle,
  'phosphor/coin': coin,
  'phosphor/cooking-pot': cookingPot,
  'phosphor/copy': copy,
  'phosphor/copyright': copyright,
  'phosphor/currency-eur': currencyEur,
  'phosphor/dots-three': dotsThree,
  'phosphor/dots-three-circle-vertical': dotsThreeCircleVertical,
  'phosphor/envelope-simple': envelopeSimple,
  'phosphor/envelope-simple-open': envelopeSimpleOpen,
  'phosphor/equals': equals,
  'phosphor/file': file,
  'phosphor/file-text': fileText,
  'phosphor/flag': flag,
  'phosphor/flag-checkered': flagCheckered,
  'phosphor/fork-knife': forkKnife,
  'phosphor/gear-six': gearSix,
  'phosphor/handbag-simple': handbagSimple,
  'phosphor/handshake': handshake,
  'phosphor/hash': hash,
  'phosphor/headset': headset,
  'phosphor/identification-card': identificationCard,
  'phosphor/image-square': imageSquare,
  'phosphor/images': images,
  'phosphor/link': link,
  'phosphor/map-pin': mapPin,
  'phosphor/map-pin-line': mapPinLine,
  'phosphor/minus': minus,
  'phosphor/minus-circle': minusCircle,
  'phosphor/note-pencil': notePencil,
  'phosphor/palette': palette,
  'phosphor/paper-plane-right': paperPlaneRight,
  'phosphor/pause-circle': pauseCircle,
  'phosphor/percent': percent,
  'phosphor/phone': phone,
  'phosphor/plus': plus,
  'phosphor/power': power,
  'phosphor/question': question,
  'phosphor/share': share,
  'phosphor/shield-check': shieldCheck,
  'phosphor/smiley': smiley,
  'phosphor/text-bolder': textBolder,
  'phosphor/text-italic': textItalic,
  'phosphor/ticket': ticket,
  'phosphor/timer': timer,
  'phosphor/traffic-sign': trafficSign,
  'phosphor/translate': translate,
  'phosphor/trash': trash,
  'phosphor/trash-simple': trashSimple,
  'phosphor/trophy': trophy,
  'phosphor/truck': truck,
  'phosphor/user-switch': userSwitch,
  'phosphor/users-four': usersFour,
  'phosphor/warning': warning,
  'phosphor/whatsapp-logo': whatsappLogo,
  'phosphor/wheelchair': wheelchair,
  'phosphor/x-circle': xCircle,
  'phosphor/x-circle-fill': xCircleFill,
  'phosphor/camera': camera,
  'phosphor/chat': chat,
  'phosphor/chat-circle-dots': chatCircleDots,
  'phosphor/clock-clockwise': clockClockwise,
  'phosphor/database': database,
  'phosphor/envelope': envelope,
  'phosphor/eraser': eraser,
  'phosphor/export': exportIcon,
  'phosphor/file-arrow-up': fileArrowUp,
  'phosphor/files': files,
  'phosphor/hand-heart': handHeart,
  'custom/house-oblique': houseObliqueCustom,
  'phosphor/image': image,
  'custom/land-follow': landFollowCustom,
  'phosphor/package': packageIcon,
  'custom/quiz': quizCustom,
  'phosphor/repeat': repeat,
  'phosphor/shopping-cart': shoppingCart,
  'phosphor/sketch-logo': sketchLogo,
  'phosphor/stack': stack,
  'custom/trolley': trolleyCustom,
  'custom/user-full': userFullCustom,
  'custom/wonder-star': wonderStarCustom,
  'phosphor/castle-turret': castleTurret,
  'phosphor/church': church,
  'phosphor/coffee': coffee,
  'phosphor/first-aid-kit': firstAidKit,
  'phosphor/pinwheel': pinwheel,
  'phosphor/road-horizon': roadHorizon,
  'phosphor/storefront': storefront,
  'phosphor/train': train,
};

export const initRegistry = (iconRegistry: SvgIconRegistryService) => () => {
  Object.entries(ICONS).forEach(([path, svg]) => {
    iconRegistry.addSvg(path.split('/')[1], svg);
    iconRegistry.addSvg(`assets/icons/${path}.svg`, svg);
  });
};

export const INIT_ICON_REGISTRY = {
  provide: APP_INITIALIZER,
  useFactory: initRegistry,
  multi: true,
  deps: [SvgIconRegistryService],
};
